import type { Page } from '../../types';
import { REPORTING_PERIOD } from './shared_variables';

const exceptions: Page[] = [
  {
    pageType: 'question',
    title: 'Exceptions',
    name: 'fair-and-open-exceptions',
    hidePageTitle: true,
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    description: `Total number of individuals appointed using an exception in the Recruitment Principles between ${REPORTING_PERIOD}.
                  Exceptions should only be reported when the candidate has a start date.`,
    questions: [
      {
        questionType: 'inset',
        title: '',
        insetContent:
          'You reported <strong>${1}</strong> people were recruited by exceptions.' +
          'Please provide a grade breakdown of these people here.',
        insetVariables: {
          1: {
            type: 'previousAnswer',
            key: 'headline-exceptions',
          },
        },
        name: 'external-recruit-exceptions-inset',
        detailsContent: 'Key contact 2 email address',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'fairAndOpenInput',
        title: 'Breakdown',
        name: 'exception-grade-column',
        label: 'Recruited by exception',
        detailsHeading: 'More information',
        detailsContent: 'If the grade does not align directly you can use the equivalent',
        rules: {
          required: true,
        },
        customValidation: {
          sumEqualToPreviousAnswer: 'headline-exceptions',
        },
      },
      // {
      //     questionType: 'textInputSmall',
      //     title: 'Total',
      //     name: 'fair-and-open-exceptions-total',
      //     // detailsContent: 'Key contact 2 email address',
      //     rules: {
      //         required: true,
      //     },
      // },
    ],
  },
];
export default exceptions;
